const makeOpportunityListQueryKey = () => {
  return ['opportunity-list'];
};

const opportunityListQueryKey = {
  list: makeOpportunityListQueryKey,
};

export default opportunityListQueryKey;
